





























































import { Component, Prop, Vue } from 'vue-property-decorator';

import { required } from 'vuelidate/lib/validators';
import { Consent, Org } from '@/api';
import { ConsentModule, OrgsModule } from '@/modules';
import Toast from '@/components/display/toast.vue';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';

@Component({
	components: { SaveCancelButtons },
	validations: {
		consent: {
			active: { required },
			consentId: { required },
			startDate: {},
			endDate: {},
			councilId: {},
			sendToCouncil: {},
		},
	},
})
export default class WaterConsentProfileEdit extends Vue {
	private consentModule: ConsentModule;
	private orgsModule: OrgsModule;
	public consent: Consent = {};
	private regionalCouncils: Org[] = [];

	@Prop() consentId?: number | undefined;
	@Prop() productId!: number;
	@Prop() modalId!: number;

	constructor() {
		super();
		this.consentModule = new ConsentModule();
		this.orgsModule = new OrgsModule();
		this.loadConsent(this.productId);
	}

	public async loadConsent(productId: number) {
		if (this.orgsModule == undefined) {
			this.orgsModule = new OrgsModule();
		}

		if (this.consentModule == undefined) {
			this.consentModule = new ConsentModule();
		}
		this.regionalCouncils = await this.orgsModule.getRegionalCouncil();
		if (this.regionalCouncils && this.regionalCouncils.length) {
			this.regionalCouncils.sort((a, b) => (a.name > b.name ? 1 : -1));
		}
		const consents = await this.consentModule.getConsentsForProduct(productId);
		//products should only have one consent
		if (consents.length === 1) {
			this.consent = consents[0];
		}
	}

	public async handleSubmit(e: any): Promise<void> {
		e.preventDefault();
		this.consent.productId = this.productId;
		const saved = await this.consentModule.save(this.consent);
		if (saved) {
			//this.$bvModal.hide(this.modalId);
			this.$emit('closeModal');
			this.$emit('reloadConsent');
		} else {
			new Toast().makeToast(
				'Error updating consent',
				'There was an error updating the consent',
				'danger',
			);
		}
	}
}
